// removed by extract-text-webpack-plugin
module.exports = {"footer":"src-components-Footer----footer-module---footer---3YcZG","container":"src-components-Footer----footer-module---container---SePS1 src-styles----index---container---1O8Oe","menu":"src-components-Footer----footer-module---menu---2jnq0 src-styles----index---menu---r8Hi9 src-styles----utils---deList---3vIUc","socialMenu":"src-components-Footer----footer-module---socialMenu---3zzH9 src-styles----utils---deList---3vIUc","colophon":"src-components-Footer----footer-module---colophon---1XSYr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/footer.module.scss
// module id = 341
// module chunks = 168707334958949